import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import DomToImage from 'dom-to-image';

import { Deferred } from '../classes/deferred';
import { Callout } from '../classes/models/callout.model';
import { util } from '../classes/util';
import { environment } from '../environment';
import { ESRI } from '../esri-loader-util';
import { IDefaultPrintTemplate, IMapcoreMapImageLayer, IPrintLayout, isFeatureLayer, isGraphicsLayer, isGroupLayer, isMapImageLayer, isSimpleRenderer, isSymbolWithOutline, isSymbolWithWidth, isTextSymbol, MapCoreLayer } from '../types';

let Graphic: __esri.GraphicConstructor;
let SymbolUtils: __esri.symbolUtils;

const blankLegendString = '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';
const maxRowsHeight = 40;
const lineWidthMultiplyer = 2;
const legendSizeMap: {
    [key: string]: {
        heightInches: number;
        widthInches: number;
        maxRows: number;
    };
} = {
    '11x8.5': {
        heightInches: 0.7803,
        widthInches: 6.827,
        maxRows: 3
    },
    '8.5x11': {
        heightInches: 1.513,
        widthInches: 4.8704,
        maxRows: 5
    },
    '17x11': {
        heightInches: 0.8,
        widthInches: 13.0767,
        maxRows: 3
    },
    '11x17': {
        heightInches: 1.5,
        widthInches: 7.3264,
        maxRows: 4
    },
    '22x17': {
        heightInches: 0.8159,
        widthInches: 18.3609,
        maxRows: 2
    },
    '17x22': {
        heightInches: 1.5024,
        widthInches: 13.3552,
        maxRows: 4
    },
    '34x22': {
        heightInches: 0.8821,
        widthInches: 30.0557,
        maxRows: 2
    },
    '22x34': {
        heightInches: 1.5582,
        widthInches: 18.265,
        maxRows: 4
    },
    '44x34': {
        heightInches: 0.7918,
        widthInches: 40.222,
        maxRows: 3
    },
    '34x44': {
        heightInches: 1.5514,
        widthInches: 30.3608,
        maxRows: 3
    }
};
const layoutSizeMap: {
    [key: string]: {
        heightInches: number;
        widthInches: number;
        drawingScale: number;
        textScale: number;
        textOffsetMultiplier: number;
    };
} = {
    '11x8.5': {
        heightInches: 6.0953,
        widthInches: 9.7527,
        drawingScale: 1.2,
        textScale: 1.1,
        textOffsetMultiplier: 3
    },
    '8.5x11': {
        heightInches: 8,
        widthInches: 7.5,
        drawingScale: 1.2,
        textScale: 1.1,
        textOffsetMultiplier: 3
    },
    '17x11': {
        heightInches: 9,
        widthInches: 16,
        drawingScale: 0.8,
        textScale: 0.9,
        textOffsetMultiplier: 3.5
    },
    '11x17': {
        heightInches: 14.125,
        widthInches: 10,
        drawingScale: 0.8,
        textScale: 0.9,
        textOffsetMultiplier: 3.5
    },
    '22x17': {
        heightInches: 14.75,
        widthInches: 21.0004,
        drawingScale: 0.6,
        textScale: 0.7,
        textOffsetMultiplier: 4.5
    },
    '17x22': {
        heightInches: 18.875,
        widthInches: 16,
        drawingScale: 0.6,
        textScale: 0.7,
        textOffsetMultiplier: 4.5
    },
    '34x22': {
        heightInches: 19.25,
        widthInches: 33,
        drawingScale: 0.3,
        textScale: 0.4,
        textOffsetMultiplier: 7.5
    },
    '22x34': {
        heightInches: 30.5,
        widthInches: 21,
        drawingScale: 0.3,
        textScale: 0.4,
        textOffsetMultiplier: 7.5
    },
    '44x34': {
        heightInches: 30.75,
        widthInches: 43,
        drawingScale: 0.1,
        textScale: 0.3,
        textOffsetMultiplier: 14
    },
    '34x44': {
        heightInches: 40.5,
        widthInches: 33.0242,
        drawingScale: 0.1,
        textScale: 0.3,
        textOffsetMultiplier: 14
    }
};
const layoutRegex = new RegExp(/(\d+\.*\d*)x(\d+\.*\d*)/);

/**
 * Maps line styles only available client-side and their nearest equivalents for printing.
 */
const clientSideOnlyLineStyleMap = {
    esriSLSLongDash: 'esriSLSDash',
    esriSLSLongDashDot: 'esriSLSDashDot',
    esriSLSLongDashDotDot: 'esriSLSDashDot',
    esriSLSShortDash: 'esriSLSDash',
    esriSLSShortDashDot: 'esriSLSDashDot',
    esriSLSShortDashDotDot: 'esriSLSDashDot',
    esriSLSShortDot: 'esriSLSDot',
    'long-dash': 'dash',
    'long-dash-dot': 'dash-dot',
    'long-dash-dot-dot': 'dash-dot',
    'short-dash': 'dash',
    'short-dash-dot': 'dash-dot',
    'short-dash-dot-dot': 'dash-dot',
    'short-dot': 'dot'
};

@Injectable({
    providedIn: 'root'
})
export class PrintService {
    /**
     * Layout URL from config
     */
    public readonly serviceUrl = environment.apiBaseUrl + '/arcgis/print';

    constructor(private readonly http: HttpClient) { }

    private heatmapImageData: { imageData: string; layerid: string; extent: __esri.Extent } = { imageData: '', layerid: '', extent: null };
    private async setupDefaultPrintBasemap(defaultPrintTemplate: IDefaultPrintTemplate, mapView: __esri.MapView) {
        let Basemap: __esri.BasemapConstructor, MapImageLayer: __esri.MapImageLayerConstructor;
        [Basemap, MapImageLayer] = await Promise.all([ESRI.Basemap, ESRI.MapImageLayer]);

        if (defaultPrintTemplate.basemap) {
            const basemap = Basemap.fromId(defaultPrintTemplate.basemap);
            mapView.map.set('basemap', basemap);
            await basemap.when();
        } else {
            const printBasemapUrl = environment.pennDotPrintBaseMapUrl;
            const basemapLayer = new MapImageLayer({ url: printBasemapUrl, legendEnabled: false }) as IMapcoreMapImageLayer;
            basemapLayer.mapcoreProps = { hideInLegend: true };
            mapView.map.layers.add(basemapLayer);
            mapView.map.reorder(basemapLayer, 0);
            await basemapLayer.when();
            return basemapLayer;
        }
        return null;
    }

    async loadLayouts(): Promise<IPrintLayout[]> {
        const layouts: IPrintLayout[] = [];
        try {
            const result = await this.http.request('GET', this.serviceUrl + '?f=json').toPromise();
            const data = result as any;
            const container = data.parameters.filter(x => x.name === 'Layout_Template')[0];
            for (let i = 0; i < container.choiceList.length; i++) {
                const template = container.choiceList[i];
                // compute the width and height of each layout
                const match = layoutRegex.exec(template);
                const layoutSize = layoutSizeMap[match[0]];
                const layout: IPrintLayout = {
                    name: template,
                    id: i + 1,
                    widthInches: layoutSize.widthInches,
                    heightInches: layoutSize.heightInches
                };
                layouts.push(layout);
            }
        } catch (error) {
            //TODO: provide error report
        }
        return layouts;
    }

    public validateServerSideLayerStyle(lineStyle: string) {
        return !(lineStyle in clientSideOnlyLineStyleMap);
    }

    /**
     * Returns a list of layers
     * @param mapView The map view to validate.
     */
    public validateServerSideLayerStyles(layers: MapCoreLayer[]): MapCoreLayer[] {
        const invalidLayers: MapCoreLayer[] = [];

        for (const layer of layers) {
            if (isFeatureLayer(layer) && isSimpleRenderer(layer.renderer)) {
                let lineStyle: string;

                if (isSymbolWithWidth(layer.renderer.symbol)) {
                    lineStyle = layer.renderer.symbol.style;
                } else if (isSymbolWithOutline(layer.renderer.symbol)) {
                    lineStyle = layer.renderer.symbol.outline.style;
                }

                if (lineStyle && lineStyle in clientSideOnlyLineStyleMap) {
                    invalidLayers.push(layer);
                }
            } else if (isGraphicsLayer(layer)) {
                for (const graphic of layer.graphics) {
                    if (isSymbolWithOutline(graphic.symbol) && graphic.symbol.outline.style in clientSideOnlyLineStyleMap
                        || isSymbolWithWidth(graphic.symbol) && graphic.symbol.style in clientSideOnlyLineStyleMap) {
                        invalidLayers.push(layer);
                        break;
                    }
                }
            }
        }

        return invalidLayers;
    }

    public getSupportedLineStyle(lineStyle: string) {
        return clientSideOnlyLineStyleMap[lineStyle];
    }

    private replaceClientSideOnlyLineStyle(symbol) {
        if (symbol.style in clientSideOnlyLineStyleMap) {
            symbol.style = clientSideOnlyLineStyleMap[symbol.style];
        }

        if (symbol.outline && symbol.outline.style in clientSideOnlyLineStyleMap) {
            symbol.outline.style = clientSideOnlyLineStyleMap[symbol.outline.style];
        }
    }

    private replaceClientSideOnlyLineStyles(layer: IOperationalLayersEntity) {
        const symbol = layer && layer.layerDefinition && layer.layerDefinition.drawingInfo && layer.layerDefinition.drawingInfo.renderer && layer.layerDefinition.drawingInfo.renderer.symbol;

        if (symbol) {
            this.replaceClientSideOnlyLineStyle(symbol);
        } else if (layer.featureCollection) {
            for (const subLayer of layer.featureCollection.layers) {
                for (const feature of subLayer.featureSet.features) {
                    this.replaceClientSideOnlyLineStyle(feature.symbol);
                }
            }
        }
    }

    /**
     * Generates a pdf or image of a map. Resolves with the url to the result
     */
    public async printMap(mapView: __esri.MapView,
        defaultPrintTemplate: IDefaultPrintTemplate,
        extent: __esri.Extent,
        includeLegend: boolean,
        emailParams: any,
        scaleDrawingLayers = false,
        useMapViewBasemap: boolean = false,
        hasRoutingDetails: boolean = false
    ): Promise<string> {
        const layers = this.replaceGroupLayers(mapView.map.layers.toArray().reverse() as MapCoreLayer[]);
        let legendImageBase64 = blankLegendString;
        if (includeLegend) {
            const legendElement = await this.buildLegendElement(defaultPrintTemplate, layers);
            const container = this.createLegendContainer(legendElement);
            legendImageBase64 = await DomToImage.toPng(legendElement, { bgcolor: 'white' });
            legendImageBase64 = legendImageBase64.replace('data:image/png;base64,', ''); // Python print service requires just the base64 text
            container.remove();
        }

        const templateName = defaultPrintTemplate.selectedLayout.name.split('(').pop().split(')')[0];
        const layoutMapSizeValues = layoutSizeMap[templateName];
        const drawingScale = (Math.ceil((extent.width > extent.height ? extent.width / mapView.extent.width : extent.height / mapView.extent.height) * 100) / 100) * layoutMapSizeValues.drawingScale;
        const textDrawingScale = (Math.ceil((extent.width > extent.height ? extent.width / mapView.extent.width : extent.height / mapView.extent.height) * 100) / 100) * layoutMapSizeValues.textScale;

        let originalDrawingLayerSizes: IDrawingLayerSymbols[] = [];
        if (scaleDrawingLayers) {
            originalDrawingLayerSizes = this.scaleDrawingLayers(mapView.map, drawingScale, textDrawingScale, layoutMapSizeValues.textOffsetMultiplier);
        } else {
            originalDrawingLayerSizes = this.scaleCalloutBoxes(mapView.map, textDrawingScale, layoutMapSizeValues.textOffsetMultiplier);
        }

        this.swapLayerFieldsProperty(mapView.map, 'fields', '_fields');

        const originalBasemap = mapView.map.basemap;
        let basemapLayer: IMapcoreMapImageLayer;
        if (!useMapViewBasemap) {
            basemapLayer = await this.setupDefaultPrintBasemap(defaultPrintTemplate, mapView);
        }

        const heatmapLayers = [];
        this.heatmapImageData = { imageData: '', layerid: '', extent: null };
        mapView.map.allLayers.forEach((layer: __esri.Layer) => {
            // check if the renderer is a HeatmapRenderer and is visible
            if (layer.type === 'feature' && layer.visible && (layer as __esri.FeatureLayer).renderer && (layer as __esri.FeatureLayer).renderer.type === 'heatmap') {
                this.heatmapImageData.layerid = layer.id;
                this.heatmapImageData.extent = mapView.extent;
                heatmapLayers.push(layer);
            }
        });
        if (heatmapLayers && heatmapLayers.length && heatmapLayers.length > 0) {
            const options: __esri.MapViewTakeScreenshotOptions = {
                format: 'png',
                quality: 100,
                layers: heatmapLayers,
                ignoreBackground: true
            };
            const screenshot = await mapView.takeScreenshot(options);
            this.heatmapImageData.imageData = screenshot.dataUrl.substr(screenshot.dataUrl.indexOf(',') + 1);
        }

        const routingDetailData = { layers: [] };
        if (hasRoutingDetails && defaultPrintTemplate.format === 'pdf') {
            mapView.map.allLayers.forEach((layer: __esri.Layer) => {
                // check if the layer has routing details, is visible, and checked in print catalog to be shown
                if (layer.type === 'graphics' && layer.visible && (layer as any).mapcoreProps && (layer as any).mapcoreProps.routingDetail && (layer as any).mapcoreProps.printRoutingDetail) {
                    routingDetailData.layers.push({
                        layerId: layer.id,
                        layerTitle: (layer as any).mapcoreProps.name,
                        routingDetail: (layer as any).mapcoreProps.routingDetail
                    });
                }
            });
        }

        await this.setupPrintExecuteInterceptor(layers, extent, basemapLayer ? basemapLayer.id : null, routingDetailData);
        let Print: __esri.print, PrintParameters: __esri.PrintParametersConstructor, PrintTemplate: __esri.PrintTemplateConstructor;
        [Print, PrintParameters, PrintTemplate] = await Promise.all([ESRI.Print, ESRI.PrintParameters, ESRI.PrintTemplate]);

        const url = Print.execute(this.serviceUrl, new PrintParameters({
            view: mapView,
            template: new PrintTemplate({
                format: defaultPrintTemplate.format,
                layout: defaultPrintTemplate.selectedLayout.name as any, // Our print services uses different names from the JS API
                layoutOptions: defaultPrintTemplate.layoutOptions,
                exportOptions: defaultPrintTemplate.exportOptions
            }),
            extraParameters: {
                ExtentJson: JSON.stringify(extent.toJSON()),
                LegendImageBase64: legendImageBase64,
                EmailParamsJson: emailParams ? JSON.stringify(emailParams) : undefined
            }
        }), { timeout: environment.printTimeout } as __esri.RequestOptions).then(result => {
            return result.url;
        });
        await this.printExecutePromise;
        this.swapLayerFieldsProperty(mapView.map, '_fields', 'fields');
        if (originalDrawingLayerSizes.length > 0) {
            this.resetDrawingLayers(originalDrawingLayerSizes);
        }
        if (!useMapViewBasemap) {
            mapView.map.basemap.set('basemap', originalBasemap);
            if (basemapLayer) {
                mapView.map.layers.remove(basemapLayer);
            }
        }
        return await url;
    }

    private replaceGroupLayers(layers: MapCoreLayer[]) {
        const retVal: MapCoreLayer[] = [];
        for (const layer of layers) {
            if (isGroupLayer(layer)) {
                layer.layers.forEach(l => l.mapcoreProps.showInPrintLegend = layer.mapcoreProps.showInPrintLegend);
                retVal.push(...layer.layers);
            } else {
                retVal.push(layer);
            }
        }
        return retVal;
    }

    private createLegendContainer(legendElement: HTMLDivElement) {
        const container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.left = '-9999px';
        container.appendChild(legendElement);
        document.body.appendChild(container);
        return container;
    }

    private async buildLegendElement(template: IDefaultPrintTemplate, layers: MapCoreLayer[]) {
        const retEl = document.createElement('div');
        if (template && template.selectedLayout) {
            this.setLegendStyles(retEl, template.selectedLayout, template.exportOptions.dpi);
        }
        if (layers && layers.length) {
            [SymbolUtils, Graphic] = await Promise.all([ESRI.SymbolUtils, ESRI.Graphic]);
            for (const layer of layers) {
                if (layer.visible && !layer.mapcoreProps.hideInLegend && layer.mapcoreProps.showInPrintLegend) {
                    retEl.append(this.buildLayerContainer(layer, (await this.getSymbolPreviewElements(layer))));
                }
            }
        }
        return retEl;
    }

    private setLegendStyles(element: HTMLDivElement, layout: IPrintLayout, dpi: number) {
        const pixelDimensions = { width: 100, height: 100, maxRows: 2 };
        const match = layoutRegex.exec(layout.name);
        const legendSize = legendSizeMap[match[0]];
        if (legendSize) {
            pixelDimensions.width = legendSize.widthInches * dpi;
            pixelDimensions.height = legendSize.heightInches * dpi;
            pixelDimensions.maxRows = legendSize.maxRows;
        }
        const scale = Math.ceil(pixelDimensions.height) / (pixelDimensions.maxRows * maxRowsHeight);

        element.style.width = `${pixelDimensions.width / scale}px`;
        element.style.height = `${pixelDimensions.height / scale}px`;

        element.style.display = 'flex';
        element.style.flexWrap = 'wrap';
        element.style.fontFamily = 'sans-serif';
        element.style.fontSize = '14px';
    }

    /* tslint:disable:cyclomatic-complexity */
    private async getSymbolPreviewElements(layer: MapCoreLayer) {
        const symbolPreviewElements: HTMLElement[] = [];
        const renderers: __esri.Renderer[] = [];
        if (isMapImageLayer(layer)) {
            for (const sublayer of layer.sublayers.toArray()) {
                if (sublayer.renderer) {
                    const renderer = util.deepClone(sublayer.renderer);
                    if (renderer && (renderer as any).symbol) {
                        (renderer as any).symbol = this.updateSymbolWithOpacity((renderer as any).symbol, layer.opacity);
                        this.sanitizeLineStyleForPrinting((renderer as any).symbol);
                    }
                    renderers.push(renderer);
                }
            }
        } else if (isGraphicsLayer(layer)) {
            let symbol: __esri.Symbol;
            if (layer.mapcoreProps && layer.mapcoreProps.symbol) {
                symbol = new Graphic({ symbol: JSON.parse(layer.mapcoreProps.symbol) }).symbol;
            } else if (layer.graphics && layer.graphics.length) {
                symbol = layer.graphics.clone().getItemAt(layer.graphics.length - 1).symbol;
            }
            if (isTextSymbol(symbol)) {
                symbol.text = 'Text';
            }
            symbol = this.updateSymbolWithOpacity(symbol, layer.opacity ? layer.opacity : 1);
            this.sanitizeLineStyleForPrinting(symbol);
            symbolPreviewElements.push(await SymbolUtils.renderPreviewHTML(symbol, { maxSize: 12, scale: true }));
        } else if (layer.type !== 'group' && layer.type !== 'base-dynamic' && !isGraphicsLayer(layer) && layer.renderer) {
            const renderer = util.deepClone(layer.renderer);
            if (renderer && (renderer as any).symbol) {
                (renderer as any).symbol = this.updateSymbolWithOpacity((renderer as any).symbol, layer.opacity);
                this.sanitizeLineStyleForPrinting((renderer as any).symbol);
            }
            renderers.push(renderer);
        }
        if (renderers.length) {
            const previewPromises: Promise<HTMLElement>[] = [];
            for (const renderer of renderers) {
                switch (renderer.type) {
                    case 'class-breaks':
                    case 'unique-value':
                        let colors = [];
                        const symbols = [];
                        const isClassBreak = renderer.type === 'class-breaks';
                        if (isClassBreak) {
                            for (const classBreak of (renderer as any).classBreakInfos) {
                                colors.push(classBreak.symbol.color);
                            }
                        } else {
                            for (const classBreak of (renderer as any).uniqueValueInfos) {
                                if (classBreak.symbol.color) {
                                    colors.push(classBreak.symbol.color);
                                } else {
                                    symbols.push(classBreak.symbol);
                                }
                            }
                        }
                        colors = colors.filter(c => c);
                        if (colors.length) {
                            previewPromises.push(Promise.resolve(SymbolUtils.renderColorRampPreviewHTML(colors.reverse(), { gradient: isClassBreak ? true : false, height: 24, width: 24 })));
                        } else if (symbols.length) {
                            for (const symbol of symbols) {
                                previewPromises.push(SymbolUtils.renderPreviewHTML(symbol, { maxSize: 14, scale: true }));
                            }
                        }
                        break;
                    case 'heatmap':
                        const heatmapColors = (renderer as __esri.HeatmapRenderer).colorStops.map(x => x.color).slice(1);
                        previewPromises.push(Promise.resolve(SymbolUtils.renderColorRampPreviewHTML(heatmapColors, { align: 'horizontal', gradient: true, height: 24, width: 24 })));
                        break;
                    default:
                        previewPromises.push(SymbolUtils.renderPreviewHTML((renderer as any).symbol, { maxSize: 14, scale: true }));
                        break;
                }
            }
            symbolPreviewElements.push(...(await Promise.all(previewPromises)));
        }
        return symbolPreviewElements;
    }

    private updateSymbolWithOpacity(symbol: __esri.Symbol, opacity: number) {
        if (symbol && symbol.color) {
            symbol.color.a *= opacity;
        }
        if (symbol && (symbol as any).outline && (symbol as any).outline.color) {
            (symbol as any).outline.color.a *= opacity;
        }

        return symbol;
    }

    private sanitizeLineStyleForPrinting(symbol: __esri.Symbol) {
        if (!symbol) {
            return;
        }

        if (isSymbolWithWidth(symbol) && symbol.style in clientSideOnlyLineStyleMap) {
            symbol.style = clientSideOnlyLineStyleMap[symbol.style];
        }

        if (isSymbolWithOutline(symbol)) {
            if (symbol.outline.style in clientSideOnlyLineStyleMap) {
                symbol.outline.style = clientSideOnlyLineStyleMap[symbol.outline.style];
            }
        }
    }

    /* tslint:enable:cyclomatic-complexity */

    private buildLayerContainer(layer: MapCoreLayer, symbolPreviewElements: HTMLElement[]) {
        const retVal = document.createElement('div');
        retVal.style.flex = '1 1 200px';

        const symbolContainer = document.createElement('div');
        symbolContainer.style.display = 'inline-block';
        symbolContainer.style.verticalAlign = 'middle';
        symbolContainer.style.width = '40px';
        symbolContainer.style.padding = '2px 5px';
        symbolContainer.append(...symbolPreviewElements);
        retVal.append(symbolContainer);

        const titleContainer = document.createElement('div');
        titleContainer.style.display = 'inline-block';
        titleContainer.style.verticalAlign = 'middle';
        symbolContainer.style.padding = '2px 5px';
        symbolContainer.style.overflow = 'hidden';
        symbolContainer.style.maxHeight = '38px';
        symbolContainer.style.maxWidth = 'calc(100% - 60px)';
        titleContainer.innerText = layer.mapcoreProps.name || layer.title;
        retVal.append(titleContainer);

        return retVal;
    }

    /**
     * Swap the field property in layers before/after printing. (Work-around to get these layers to print.)
     */
    private swapLayerFieldsProperty(map, sourceProperty, destProperty) {
        if (map._layers) {
            for (const layerId of map._layers) {
                const layer = map._layers[layerId];
                if (layer[sourceProperty]) {
                    layer[destProperty] = layer[sourceProperty];
                    layer[sourceProperty] = undefined;
                }
            }
        }
    }

    private scaleDrawingLayers(map: __esri.Map, scale: number, textScale: number, textOffsetMultiplier: number): IDrawingLayerSymbols[] {
        const retVal: IDrawingLayerSymbols[] = [];
        const graphicsLayers = map.layers.filter(layer => layer.type === 'graphics').toArray();
        for (const graphicLayer of graphicsLayers) {
            const originalSymbols: IDrawingLayerSymbols = { layerId: graphicLayer.id, toReset: [] };
            const layer = map.findLayerById(graphicLayer.id) as __esri.GraphicsLayer;
            for (const graphic of layer.graphics.toArray()) {
                const symbol = graphic.symbol;
                originalSymbols.toReset.push({ symbol: { type: symbol.type, json: symbol.toJSON() }, graphic });
                this.scaleSymbol(symbol, scale, textScale, textOffsetMultiplier);
            }
            retVal.push(originalSymbols);
        }
        return retVal;
    }

    private scaleCalloutBoxes(map: __esri.Map, textScale: number, textOffsetMultiplier: number): IDrawingLayerSymbols[] {
        const retVal: IDrawingLayerSymbols[] = [];
        const callouts = Callout.fromLayers(map.layers.filter(layer => layer.type === 'graphics').map(layer => layer as __esri.GraphicsLayer).toArray());
        for (const callout of callouts) {
            const originalSymbols: IDrawingLayerSymbols = { layerId: callout.graphicsLayer.id, toReset: [] };
            const symbol = callout.textGraphic.symbol as __esri.TextSymbol;
            originalSymbols.toReset.push({ symbol: { type: symbol.type, json: symbol.toJSON() }, graphic: callout.textGraphic });
            symbol.font.size = symbol.font.size / textScale;
            this.offsetText(symbol, textOffsetMultiplier, textScale);
            retVal.push(originalSymbols);
        }
        return retVal;
    }

    private scaleSymbol(symbol: __esri.Symbol, scale: number, textScale: number, textOffsetMultiplier: number) {
        switch (symbol.type) {
            case 'simple-marker':
                const smSymbol = symbol as __esri.symbols.SimpleMarkerSymbol;
                if (smSymbol.size) { smSymbol.size = Math.ceil(smSymbol.size * (scale * 1.25)); }
                if (smSymbol.outline && smSymbol.outline.width) { smSymbol.outline.width = Math.ceil(smSymbol.outline.width * scale); }
                break;
            case 'picture-marker':
                const pmSymbol = symbol.toJSON() as __esri.symbols.PictureMarkerSymbol;
                if (pmSymbol.height) { pmSymbol.height = Math.ceil(pmSymbol.height * scale); }
                if (pmSymbol.width) { pmSymbol.width = Math.ceil(pmSymbol.width * scale); }
                break;
            case 'simple-line':
                const slSymbol = symbol as __esri.symbols.SimpleLineSymbol;
                if (slSymbol.width) { slSymbol.width = Math.ceil(slSymbol.width * scale); }
                break;
            case 'simple-fill':
                const sfSymbol = symbol as __esri.symbols.SimpleFillSymbol;
                if (sfSymbol.outline && sfSymbol.outline.width) { sfSymbol.outline.width = Math.ceil(sfSymbol.outline.width * scale); }
                break;
            case 'picture-fill': // This one may have some trouble
                const pfSymbol = symbol as __esri.symbols.PictureFillSymbol;
                if (pfSymbol.height) { pfSymbol.height = Math.ceil(pfSymbol.height * scale); }
                if (pfSymbol.width) { pfSymbol.width = Math.ceil(pfSymbol.width * scale); }
                if (pfSymbol.xscale) { pfSymbol.xscale = Math.ceil(pfSymbol.xscale * scale); }
                if (pfSymbol.yscale) { pfSymbol.yscale = Math.ceil(pfSymbol.yscale * scale); }
                break;
            case 'text': // May want to exclude this, as it's tied to the screen instead of the map
                const tSymbol = symbol as __esri.symbols.TextSymbol;
                if (tSymbol.font && tSymbol.font.size) { tSymbol.font.size = Math.ceil(tSymbol.font.size / textScale); }
                this.offsetText(tSymbol, textOffsetMultiplier, textScale);
                break;
            default:
                throw new Error('Symbol type for scaling not valid: ' + symbol.type);
        }
    }

    private offsetText(symbol: __esri.symbols.TextSymbol, textOffsetMultiplier: number, textScale: number) {
        const characterMax = Math.floor(((symbol.lineWidth / textScale) / symbol.font.size) * lineWidthMultiplyer);
        const newlineRegex = new RegExp(`(?![^\n]{1,${characterMax}}$)([^\n]{1,${characterMax}})\\s`, 'g');
        symbol.text = symbol.text.replace(newlineRegex, '$1\n');
        if (symbol.yoffset < 0) {
            symbol.yoffset = (-symbol.yoffset) * textOffsetMultiplier;
        } else {
            symbol.yoffset = symbol.yoffset * (textOffsetMultiplier * 2);
        }
    }

    private async resetDrawingLayers(oldValues: IDrawingLayerSymbols[]) {
        for (const drawingLayerSymbols of oldValues) {
            for (const resetItem of drawingLayerSymbols.toReset) {
                await this.setSymbol(resetItem.symbol, resetItem.graphic); // Maybe we don't need to wait for this to complete?
            }
        }
    }

    private async setSymbol(symbolInfo: ISymbolInfo, graphic: __esri.Graphic) {
        switch (symbolInfo.type) {
            case 'simple-marker':
                const SimpleMarkerSymbol = await ESRI.SimpleMarker;
                graphic.symbol = SimpleMarkerSymbol.fromJSON(symbolInfo.json);
                break;
            case 'picture-marker':
                const PictureMarkerSymbol = await ESRI.PictureMarker;
                graphic.symbol = PictureMarkerSymbol.fromJSON(symbolInfo.json);
                break;
            case 'simple-line':
                const SimpleLineSymbol = await ESRI.SimpleLine;
                graphic.symbol = SimpleLineSymbol.fromJSON(symbolInfo.json);
                break;
            case 'simple-fill':
                const SimpleFillSymbol = await ESRI.SimpleFill;
                graphic.symbol = SimpleFillSymbol.fromJSON(symbolInfo.json);
                break;
            case 'picture-fill':
                const PictureFillSymbol = await ESRI.PictureFill;
                graphic.symbol = PictureFillSymbol.fromJSON(symbolInfo.json);
                break;
            case 'text':
                const TextSymbol = await ESRI.TextSymbol;
                graphic.symbol = TextSymbol.fromJSON(symbolInfo.json);
                break;
            default:
                throw new Error('Saved symbol type not valid: ' + symbolInfo.type);
        }
    }

    private printExecutePromise: Promise<void>;

    /* tslint:disable:cyclomatic-complexity */
    private async setupPrintExecuteInterceptor(layers: MapCoreLayer[], extent: __esri.Extent, printBasemapLayerId?: string, routingDetailData?: any) {
        const defferer = new Deferred<void>();
        this.printExecutePromise = defferer.promise;
        const esriConfig = await ESRI.Config;
        const removeInterceptor = (int: __esri.RequestInterceptor) => {
            esriConfig.request.interceptors.splice(esriConfig.request.interceptors.indexOf(int), 1);
            defferer.resolve();
        };
        const interceptor: __esri.RequestInterceptor = {
            urls: [`${environment.apiBaseUrl}/arcgis/print/execute`],
            before: (params: IEsriPrintRequestParams) => {
                // Fix the map extent
                const webMap = JSON.parse(params.requestOptions.query.Web_Map_as_JSON) as IWebMapObject;
                webMap.mapOptions.extent = extent.toJSON() as IExtent;
                if (routingDetailData) {
                    webMap.layoutOptions.routingDetailData = this.getRoutingDetailsForPrint(routingDetailData);
                }
                const opLayers: IOperationalLayersEntity[] = [];
                if (webMap.operationalLayers && webMap.operationalLayers.length) {
                    if (printBasemapLayerId) {
                        const printBasemapLayer = webMap.operationalLayers.find(layer => layer.id === printBasemapLayerId);
                        if (printBasemapLayer && printBasemapLayer.visibleLayers) {
                            delete printBasemapLayer.visibleLayers;
                            delete printBasemapLayer.layers;
                        }
                        webMap.operationalLayers = webMap.operationalLayers.filter(layer => layer.type !== 'WebTiledLayer');
                    }
                    let previousLayer: IOperationalLayersEntity = null;

                    for (const opLayer of webMap.operationalLayers) {
                        const matchingLayer = layers.find(l => l.id === opLayer.id);
                        if (matchingLayer && matchingLayer.mapcoreProps) {
                            opLayer.title = matchingLayer.mapcoreProps.name;
                            if (opLayer.layers) {
                                opLayer.layers[0].name = matchingLayer.mapcoreProps.name;
                            }
                        }

                        this.replaceClientSideOnlyLineStyles(opLayer);

                        if (opLayer && opLayer.layers && opLayer.layers.length > 0) {
                            //when previous and current layer are both or both not visual variables, group them together
                            const layerHasVisualVariables = JSON.stringify(opLayer.layers).toLowerCase().indexOf('visualvariables') > -1;
                            const preLayerHasVisualVariables = (previousLayer && previousLayer.layers) ? JSON.stringify(previousLayer.layers).toLowerCase().indexOf('visualvariables') > -1 : false;
                            if (layerHasVisualVariables) {
                                opLayer.url = opLayer.url.replace('/mapcore/', '/mapcorepro/');
                            }
                            if (previousLayer && previousLayer.layers && previousLayer.layers.length > 0 && layerHasVisualVariables === preLayerHasVisualVariables) {
                                previousLayer.layers = opLayer.layers.concat(previousLayer.layers);
                            } else {
                                previousLayer = { ...opLayer };
                                opLayers.push(previousLayer);
                            }
                        } else if (this.heatmapImageData && this.heatmapImageData.layerid === opLayer.id) {
                            const heatMapImageLayer: IOperationalLayersEntity = {
                                id: opLayer.id + '_heatmap',
                                type: 'image',
                                title: null,
                                minScale: 0,
                                maxScale: 0,
                                opacity: 1,
                                extent: this.heatmapImageData.extent.toJSON() as IExtent,
                                imageData: this.heatmapImageData.imageData,
                                urlTemplate: '',
                                credits: ''
                            };
                            previousLayer = null;
                            opLayers.push(heatMapImageLayer);
                        } else {
                            if (opLayer.id && opLayer.id.indexOf('mc-print-extent') < 0) {
                                opLayers.push(opLayer);
                            }
                            previousLayer = null;
                        }
                    }
                    webMap.operationalLayers = opLayers;
                }
                if (webMap.layoutOptions && webMap.layoutOptions.legendOptions && webMap.layoutOptions.legendOptions.operationalLayers && webMap.layoutOptions.legendOptions.operationalLayers.length && webMap.layoutOptions.legendOptions.operationalLayers.length > 0 && opLayers) {
                    if (printBasemapLayerId) {
                        webMap.layoutOptions.legendOptions.operationalLayers = webMap.layoutOptions.legendOptions.operationalLayers.filter(layer => layer.id !== printBasemapLayerId);
                    }
                    webMap.layoutOptions.legendOptions.operationalLayers = [{
                        id: 'MapcoreDynamicLayer',
                        subLayerIds: [...webMap.layoutOptions.legendOptions.operationalLayers.map(x => x.subLayerIds).flat()].reverse()
                    }];
                }
                params.requestOptions.query.Web_Map_as_JSON = JSON.stringify(webMap);

                const cookieRow = document.cookie.split('; ').map((item) => item.split('=')).find((item) => item[0] === 'PDAuth_token');
                if (cookieRow) {
                    const pdAuthToken = cookieRow[1];
                    if (!params.requestOptions.headers) {
                        params.requestOptions.headers = {
                            'X-Auth-Token': pdAuthToken
                        };
                    } else {
                        params.requestOptions.headers['X-Auth-Token'] = pdAuthToken;
                    }
                }

                removeInterceptor(interceptor);
            },
            error: ((er: __esri.Error) => {
                removeInterceptor(interceptor);
                throw (er);
            })
        };
        esriConfig.request.interceptors.push(interceptor);
    }

    private getRoutingDetailsForPrint(routingDetailData: any): string[][] {
        const routingDetailText: string[][] = [];
        if (routingDetailData.layers && routingDetailData.layers.length > 0) {
            routingDetailData.layers.forEach(layer => {
                const routingText: string[] = [];
                routingText.push(`Layer: ${layer.layerTitle}`);
                routingText.push(`Distance: ${layer.routingDetail.distance.toFixed(2)} ${layer.routingDetail.unit}`);
                if (layer.routingDetail.directions && layer.routingDetail.directions.features && layer.routingDetail.directions.features.length > 0) {
                    layer.routingDetail.directions.features.forEach(feature => {
                        let directionText = feature.attributes.text;
                        if (feature.attributes.length) {
                            directionText += ` - ${feature.attributes.length.toFixed(2) } ${layer.routingDetail.unit}`;
                        }
                        routingText.push(directionText);
                    });
                }
                routingDetailText.push(routingText);
            });
        }
        return routingDetailText;
    }
}
interface IEsriPrintRequestParams {
    url: string;
    requestOptions: {
        timeout: number;
        query: {
            Web_Map_as_JSON: string;
            Format: string;
            Layout_Template: string;
            ExtentJson: string;
            f: 'json' | 'html';
        };
        headers?: any;
    };
}

interface IWebMapObject {
    operationalLayers?: IOperationalLayersEntity[];
    mapOptions: IMapOptions;
    exportOptions: {
        dpi: number;
    };
    layoutOptions: {
        titleText: string;
        authorText: string;
        copyrightText: string;
        customTextElements?: any[];
        routingDetailData?: string[][];
        scaleBarOptions: any;
        legendOptions: {
            operationalLayers: {
                id: string;
                subLayerIds;
            }[];
        };
    };
}

interface IOperationalLayersEntity {
    type: string;
    urlTemplate: string;
    credits: string;
    id: string;
    title?: string;
    opacity: number;
    minScale: number;
    maxScale: number;
    layers?: {
        id: number;
        layerDefinition: any;
        name: string;
    }[];
    visibleLayers?: number[];
    imageData?: string;
    extent?: IExtent;
    url?: string;
    layerDefinition?: any;
    featureCollection?: any;
}
interface IMapOptions {
    extent: IExtent;
    spatialReference: ISpatialReference;
    showAttribution: boolean;
    scale: number;
}
interface IExtent {
    spatialReference: ISpatialReference;
    xmin: number;
    ymin: number;
    xmax: number;
    ymax: number;
}
interface ISpatialReference {
    latestWkid: number;
    wkid: number;
}

export interface IDrawingLayerSymbols {
    layerId: string;
    toReset: {
        graphic: __esri.Graphic;
        symbol: ISymbolInfo;
    }[];
}

export interface ISymbolInfo {
    type: string;
    json: any;
}
